export default __webpack_public_path__ + "static/media/PC_image@2x.2aee9f9f.png";